<template>
  <div class="welfare" v-if="havehongbao > 0">
    <div class="left">
      <div class="name">红包福利</div>
      <img
        src="https://img2.233.com/wx/union/618/2021/pc/welfare-red-packet.png"
      />
    </div>
    <div class="right">
      <div
        :class="welfareList.length >= 4 ? 'box' : 'box three'"
        v-for="(item, key) in welfareList.slice(0, 4)"
        :key="key"
      >
        <div class="price">
          <span>￥</span>
          <label>{{ item.MaxPrice }}</label>
        </div>
        <div class="ps">
          <p>满{{ item.HDHaveMoney }} - {{ item.HDCutMoney }}元</p>
          <p>
            使用时间：{{ formatDate(item.StartDate, 1) }}-{{
              formatDate(item.CloseDate, 1)
            }}
          </p>
        </div>
        <div class="button already" v-if="item.HaveHongbao === 1">领取成功</div>
        <template v-else>
          <div
            class="button"
            v-if="insideTime(item.ReceiveStartDate, item.ReceiveCloseDate)"
            @click="LingQuHongBao(item.ActitityDetailId)"
          >
            免费领取
          </div>
          <div class="button not-started" v-else>
            {{ formatDate(item.ReceiveStartDate) }}-{{
              formatDate(item.ReceiveCloseDate)
            }}领取
          </div>
        </template>
        <div class="range">{{ item.HongBaoUseCourse }}</div>
        <img
          src="https://img2.233.com/wx/union/618/2021/pc/hbfl-label-img.png"
          class="new-student"
          v-if="item.UserType === 1"
        />
        <img
          src="https://img2.233.com/wx/union/618/2021/pc/hbfl-label-img2.png"
          class="old-student"
          v-if="item.UserType === 2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { GetHongBaoInfo, LingQuHongBao } from "../../../lib/request";
export default {
  name: "Welfare",
  props: {
    curTime: {
      type: Number,
      default: 0,
    },
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      havehongbao: 0,
      welfareList: [],
    };
  },
  mounted() {
    this.GetHongBaoInfo();
  },
  methods: {
    GetHongBaoInfo() {
      GetHongBaoInfo({}, (res) => {
        const { havehongbao = 0, hbList = [] } = res.Result;
        this.havehongbao = havehongbao;
        this.welfareList = hbList;
        havehongbao > 0 && this.$emit("updateVisibilit", "welfare");
      });
    },
    insideTime(startTime, endTime) {
      return (
        this.curTime >= new Date(startTime).getTime() &&
        this.curTime <= new Date(endTime).getTime()
      );
    },
    formatDate(time, type) {
      const _time = new Date(time);
      return type
        ? _time.getFullYear() +
            "年" +
            (_time.getMonth() + 1) +
            "月" +
            _time.getDate()
        : _time.getMonth() + 1 + "日" + _time.getDate();
    },
    LingQuHongBao(actitityDetailId) {
      if (this.isLogin) {
        LingQuHongBao({ fromweb: 1, actitityDetailId }, (res) => {
          if (!res.ResultDescription) {
            if (res.Result) {
              this.$emit("openTip", { type: 1, text: "领取成功" });
              this.GetHongBaoInfo();
            } else {
              this.$emit("openTip", { type: 2, text: "领取失败" });
            }
          } else {
            this.$emit("openTip", { type: 2, text: res.ResultDescription });
          }
        });
      } else {
        window.location.href =
          window.location.origin +
          "/uc/login?redirecturl=" +
          window.location.href;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.welfare {
  margin: 0 auto 90px;
  width: 1133px;
  position: relative;
  height: 282px;
  padding-left: 144px;
  box-sizing: border-box;
  .left {
    position: absolute;
    top: 0;
    left: 0;
    background: url("https://img2.233.com/wx/union/618/2021/pc/welfare.png")
      no-repeat top center;
    width: 226px;
    height: 282px;
    padding: 40px 0 0 23px;
    box-sizing: border-box;
    z-index: 1;
    .name {
      color: #ffe8cd;
      font-size: 30px;
      line-height: 36px;
      font-weight: 800;
      width: 72px;
    }
    img {
      position: absolute;
      bottom: -103px;
      left: -10px;
      width: 142px;
      height: 227px;
    }
  }
  .right {
    left: 35px;
    position: relative;
    z-index: 2;
    width: 100%;
    height: 260px;
    box-sizing: border-box;
    .box {
      width: 224px;
      height: 282px;
      display: inline-block;
      background: url("https://img2.233.com/wx/union/618/2021/pc/welfare-box4.png")
        no-repeat top center;
      margin-right: 18px;
      text-align: center;
      position: relative;
      &:nth-last-child(1) {
        margin-right: 0;
      }
      .price {
        margin: 29px 0 10px;
        span {
          color: #f8a258;
          font-size: 48px;
          font-weight: 800;
          line-height: 68px;
        }
        label {
          color: #f8a258;
          font-size: 68px;
          font-weight: 800;
          line-height: 68px;
        }
      }
      .ps {
        width: 200px;
        padding-left: 22px;
        p {
          color: #863809;
          font-size: 13px;
          font-weight: 400;
          text-align: left;
          line-height: 22px;
        }
      }
      .button {
        display: inline-block;
        width: 180px;
        height: 44px;
        line-height: 44px;
        background: linear-gradient(-75deg, #e00f23, #fa5e53);
        box-shadow: 0px 2px 10px 0px rgba(200, 49, 58, 0.38);
        border-radius: 22px;
        color: #fff;
        font-size: 22px;
        margin: 10px 0;
        cursor: pointer;
      }
      .already {
        opacity: 0.5;
        cursor: not-allowed;
      }
      .not-started {
        background: linear-gradient(-75deg, #e00f23, #fa5e53);
        box-shadow: 0px 2px 10px 0px rgba(200, 49, 58, 0.38);
        color: #fff;
        opacity: 0.5;
        font-size: 18px;
      }
      .range {
        color: #555;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 30px;
        box-sizing: border-box;
      }
      .new-student,
      .old-student {
        position: absolute;
        top: 12px;
        left: 10px;
      }
    }
    // .three{
    //   width: 306px;
    //   height: 282px;
    //   display: inline-block;
    //   background: url('https://img2.233.com/wx/union/618/2021/pc/welfare-box3.png') no-repeat top center;
    //   margin-right: 18px;
    //   text-align: center;
    //   position: relative;
    //   .ps{
    //     padding-left: 63px;
    //   }
    // }
  }
}
</style>
